"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMediaComponent = void 0;
const react_1 = __importDefault(require("react"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const RepeatableRender_1 = __importDefault(require("../wrappers/RepeatableRender"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
const FileManagementRender_1 = require("../wrappers/FileManagementRender");
/**
 * This is a helper function to create the most typical type of Page component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 * @param componentType the form component type name that we are building
 */
const generateMediaComponent = (controlProvider, componentType) => {
    const NewComponent = (props) => {
        const Control = controlProvider[componentType];
        const { controlDefinition, controlPath, values, value, displayMap, hidden } = props;
        return (react_1.default.createElement(RepeatableRender_1.default, { value: value, values: values, controlPath: controlPath, controlDefinition: controlDefinition, renderControl: (repeatableProps) => {
                return (react_1.default.createElement(ValidationOptimizer_1.default, { controlDefinition: controlDefinition, key: repeatableProps.key, displayMap: displayMap, render: (validationFn) => {
                        return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, validationFn: validationFn, value: repeatableProps.value, values: values, render: (fieldProps) => {
                                var _a;
                                return ((_a = fieldProps.displayOptions) === null || _a === void 0 ? void 0 : _a.isVisible) !== false && !hidden ? (react_1.default.createElement(FileManagementRender_1.FileManagementRender, { controlDefinition: controlDefinition, onChange: () => { }, value: fieldProps.value, render: (fileProps) => {
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        //@ts-ignore
                                        return react_1.default.createElement(Control, Object.assign({}, fieldProps, repeatableProps, fileProps));
                                    } })) : react_1.default.createElement(react_1.default.Fragment, null);
                            } }));
                    } }));
            } }));
    };
    NewComponent.displayName = `ConditionalRepeatableValidatedField => ${componentType}`;
    return NewComponent;
};
exports.generateMediaComponent = generateMediaComponent;
